import Vue from 'vue'

class Breadcrumbs
{
    stack = Vue.observable([]);

    push(uniqueId, title, clickHandler) {
        const found = this.stack.find((item) => {
            return item.id === uniqueId
        });

        if (!found) {
            const item = new Item(uniqueId, title, clickHandler, this);
            const length = this.stack.push(item);
            item.index = length - 1;
        }
    }

    clear() {
        this.stack.splice(0);
    }

    getItems() {
        return this.stack;
    }

    count() {
        return this.stack.length;
    }

    back() {
        if (this.stack.length >= 2) {
            this.stack[this.stack.length - 2].click();
        }
    }

    __doPop(item) {
        this.stack.splice(item.index);
    }
}

class Item
{
    id;
    index;
    breadcrumbs;
    title;
    handler;

    constructor(id, title, clickHandler, breadcrumbs) {
        this.id = id;
        this.breadcrumbs = breadcrumbs;
        this.title = title;
        this.handler = clickHandler;
    }

    click() {
        this.handler.call(null);
        this.breadcrumbs.__doPop(this);
    }
}

export default new Breadcrumbs();
